import React from "react";
import Header from "../components/Header";
import About from "../components/About";
import Skills from "../components/Skills";
import Projects from "../components/Projects";

const Home: React.FC = () => {
  return (
    <div
      className="mx-auto w-full max-w-[1100px] px-4 sm:px-6 lg:px-8 overflow-x-hidden"
    >
      <Header />
      <main>
        <section id="about" className="py-8 sm:py-12">
          <About />
        </section>
        <section id="skills" className="py-8 sm:py-12">
          <Skills />
        </section>
        <section id="projects" className="py-8 sm:py-12">
          <Projects />
        </section>
      </main>
    </div>
  );
};

export default Home;
